import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";

export interface MST3010_R01Dto extends WorkPlaceDto {

	inWarehouseNm: string;
	outWarehouseNm: string;
	badWarehouseNm: string;
	workEmpNm: string;

}



/** "연동 PLC ID" 선택 목록 1건 (GET /MST3010_R01/plc 응답, 백엔드 PlcConnectionMasterDto) */
export interface PlcConnectionMasterDto {
	plcId: string; // PLC 고유번호 (예: PLC01)
	compCd: string; // 사업장코드 — 화면에서 선택한 사업장의 PLC만 보여주는 데 사용
	plcName: string; // PLC(설비) 이름
	useYn: string; // 수집 사용 여부 (서버에서 'Y'만 내려옴)
}

// 기본 작업장 데이터
export const defaultMST3010_R01Dto: MST3010_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	workplaceCd: '',
	workplaceNm: '',
	compCd: '',
	compNm: '',
	displaySeq: 0,
	workProcess: '',
	useYn: 'Y',
	orderYn: 'Y',
	barcodePrint: 'Y',
	levelCd: '',
	outsourcingYn: 'Y',
	scanHistory: 'Y',
	faultyYn: 'Y',
	logicCenter: '',
	inWarehouse: '',
	outWarehouse: '',
	badWarehouse: '',
	workEmpNo: '',
	remark: '',
	plcId: '',
	dayStartCount: 0,
	lotStartCount: 0,

	inWarehouseNm: '',
	outWarehouseNm: '',
	badWarehouseNm: '',
	workEmpNm: '',

	inserted: false,
	isModified: false,

	insertDt: new Date(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: ''
};
